/**
 * 加载script
 * @param src - script url
 * @param mountObj - 加载脚本挂载到的位置，默认为window
 * @param key - 该对象在mountObj下的key值，如mountObj为window即window[key]
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getScript<T>(src: string, mountObj: Record<string, any>, key: string): Promise<T> {
  if (mountObj && !key) {
    return Promise.reject('if specified mountObj then must have key');
  }
  const node = document.createElement('script');
  node.src = src;
  node.type = 'text/javascript';
  document.body.append(node);
  return new Promise<T>((resolve, reject) => {
    node.onload = function () {
      document.body.removeChild(node);
      const obj = mountObj?.[key];
      if (!obj) {
        reject('script not found');
      }
      resolve(obj as T);
      return;
    };
    node.onerror = function (err) {
      document.body.removeChild(node);
      reject(err);
    };
  });
}
